export default __webpack_public_path__ + "static/media/welcome.8e01489a.mp4";